export const SET_STREAMING = 'ROOM/STREAMING/SET_STREAMING'
export const SET_STREAMINGS = 'ROOM/STREAMING/SET_STREAMINGS'
